const colors = {
  primary: "#2b2b2b",
  secondary: "#ececec",
  buttonColor: "#3c85b7",
  buttonText: "#fff",
};

export default colors;
